import React from 'react';
import {
    Box,
    List,
    ListItem,
    ListItemText,
    Divider,
} from '@mui/material';
import { SETTINGS_CATEGORIES } from './config/SettingsCategories';
import { SETTINGS_CONFIG } from './config/SettingsConfig';
import FeatureFlagBadge from './FeatureFlagBadge';

const StoreSettings = ({ storeId, selectedStoreConfiguration }) => {
    const storeFlagsMapped = Object.entries(SETTINGS_CATEGORIES)
    .map(([categoryKey, category]) => ({
        category: category.label,
        data: category.settings
            .filter((settingKey) => SETTINGS_CONFIG.store[settingKey])
            .map((settingKey) => {
                const configItem = SETTINGS_CONFIG.store[settingKey];
                return {
                    label: configItem.label || settingKey.replace(/_/g, " "),
                    active: selectedStoreConfiguration[configItem.propertyName] || false,
                };
            }),
    }))
    .filter((setting) => setting.data.length > 0);

    return (
        <List>
            {storeFlagsMapped.map((setting, index) => (
                <React.Fragment key={index}>
                    <ListItem className="menu-actions-container">
                        <ListItemText
                            primary={setting.category}
                            primaryTypographyProps={{ fontWeight: 'bold' }}
                        />
                    </ListItem>
                    {setting.data.map((item, idx) => {
                        return (
                            <ListItem key={idx} className='feature-flag-container'>
                                <FeatureFlagBadge title={item.label} activeSetting={item.active} />
                            </ListItem>
                    )})}
                    <Divider component="li" sx={{ marginTop: '1em' }} />
                </React.Fragment>
            ))}
        </List>
    );
};

export default StoreSettings;